import { gql } from "@apollo/client";

export const GET_SETTING = gql`
  query Setting($where: SettingWhereInputOne!) {
  setting(where:$where) {
      id
      facebook
      facebookSummary
      facebookPost
      bank  
      live
      post
      logistic
      tags
      bankQr
      isSummaryFirst
    	shop{
        id
      }
      msgType
      autoReceive
      flowPaymentFirst
  }
}
`;

export const GET_SETTINGS = gql`
  query Settings($where: SettingWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  settings(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    data {
      id
      facebook
      facebookSummary
      facebookPost
      fbClaimBalanceMsg
      bank
      live
      post
      logistic
      tags
      isSummaryFirst
      bankQr
    	shop{
        id
      }
      msgType
      autoReceive
      flowPaymentFirst
    }
  }
}
`;

export const GET_ADVERTISINGS = gql`
query Advertisements($where: AdvertisingWhereInput) {
  advertisements(where: $where) {
    data {
      id
      name
      startDate
      endDate
      link
      status
      note
      image
    }
    total
  }
}
`;

export const GET_SETTING_BY_SHOP = gql`
  query SettingByShopId($where: SettingWhereInput) {
    settingByShopId(where: $where) {
      id
      latLong
      deliveryOfPoint
      halIsOpen
      halCOD
      mxIsOpen
      mxCOD
      ansIsOpen
      ansCOD
      note
      logisticsCOD
      facebook
      facebookSummary
      facebookPost
      facebookPostSummary
      post
      live
      logistic
      tags
      isSummaryFirst
      bankQr
      createdAt
      updatedAt
      notifyClaimBalance
      notifyPaid
      notifyDlv
      notifyDlvDestination
      notifyComplete
      phone
      isPaymentGateway
      isUseLogistics
      isLimitedOrder
      isLimitetPage
      isUseSalePage
      isLiveSiriVoice
      orderPoint
      multipleOdFrmCm
      flowPaymentFirst
      msgType
      autoReceive
      sCodeStartWithO
      sp_cod
      shop {
        name
        id
        phone
        systems
        address {
          province
          district
          village
        }
      }
    }
  }
`